import {
  GenieLogo_default
} from "./chunk-FU2RPPBJ.js";
import {
  AskGenieIcon_default
} from "./chunk-5NLMKKTE.js";
import {
  BuilderIcon_default
} from "./chunk-YED5ZWKI.js";
import {
  CreatorIcon_default
} from "./chunk-QBQ64CAM.js";
import {
  GenieIcon_default
} from "./chunk-FU22NRZL.js";
import {
  __export
} from "./chunk-PZ5AY32C.js";

// src/components/ui/icon/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  AskGenieIcon: () => AskGenieIcon_default,
  BuilderIcon: () => BuilderIcon_default,
  CreatorIcon: () => CreatorIcon_default,
  GenieIcon: () => GenieIcon_default,
  GenieLogo: () => GenieLogo_default
});

export {
  icons_exports
};
//# sourceMappingURL=chunk-SWSTXSFC.js.map